// SPDX-License-Identifier: AGPL-3.0-or-later

import * as GiftCommands from '@app/features/gift/commands/GiftCommands';
import * as PremiumCommands from '@app/features/premium/commands/PremiumCommands';
import styles from '@app/features/premium/components/experience/PremiumGiftRedeem.module.css';
import {SHOPIER_COPY} from '@app/features/premium/utils/ShopierCopy';
import {useLingui} from '@lingui/react/macro';
import {GiftIcon} from '@phosphor-icons/react';
import {useState} from 'react';

export const PREMIUM_GIFT_CODE_INPUT_ID = 'premium-gift-code';

export function PremiumGiftRedeem() {
	const {i18n} = useLingui();
	const [code, setCode] = useState('');
	const [busy, setBusy] = useState(false);
	const trimmed = code.trim();

	const redeem = async (event: React.FormEvent) => {
		event.preventDefault();
		if (!trimmed || busy) return;
		setBusy(true);
		try {
			await GiftCommands.redeem(i18n, trimmed);
			setCode('');
			void PremiumCommands.refreshPremiumState();
		} catch {
		} finally {
			setBusy(false);
		}
	};

	return (
		<form className={styles.root} onSubmit={(event) => void redeem(event)} data-flx="premium.gift-redeem">
			<span className={styles.icon} aria-hidden="true">
				<GiftIcon weight="fill" size={18} />
			</span>
			<label className={styles.label} htmlFor={PREMIUM_GIFT_CODE_INPUT_ID}>
				{i18n._(SHOPIER_COPY.giftTitle)}
			</label>
			<input
				id={PREMIUM_GIFT_CODE_INPUT_ID}
				className={styles.input}
				value={code}
				onChange={(event) => setCode(event.target.value)}
				placeholder={i18n._(SHOPIER_COPY.giftPlaceholder)}
				autoComplete="off"
				spellCheck={false}
				maxLength={128}
			/>
			<button type="submit" className={styles.button} disabled={!trimmed || busy} aria-busy={busy || undefined}>
				{i18n._(SHOPIER_COPY.giftRedeem)}
			</button>
		</form>
	);
}
